<template>
  <div class="clients">
    <div class="filter">
      <div class="section-header">
        <el-row><span>Residents: {{ clients.length }}</span></el-row>
      </div>
    </div>
    <el-table
    :data="clients"
    style="width: 100%"
    :default-sort = "{prop: 'onSetDate', order: 'descending'}"
    >
      <el-table-column
        fixed
        label=" "
        width="100">
        <template scope="scope">
          <div style="padding: 0.5em;">
          <div :span="4" class="profile-row-photo" v-if="scope.row.photo"><img :src="photoUrl(scope.row.photo)"></div>
          <div :span="4" class="profile-row-photo" v-else><img src="~assets/user.png"></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="Name"
        sortable
        fixed
        width="180">
        <template scope="scope">
          {{clientName(scope.row)}}
        </template>
      </el-table-column>
      <el-table-column
        label="Gender"
        width="140">
        <template scope="scope">
          <span v-if="scope.row.gender">{{ scope.row.gender }}</span>
          <span v-else>Not Entered</span>
        </template>
      </el-table-column>
      <el-table-column
        label="DOB"
        prop="dateOfBirth"
        width="180">
        <template scope="scope">
          <span v-if="scope.row.dateOfBirth">{{ scope.row.dateOfBirth | moment('DD-MM-YYYY') }}</span>
          <span v-else>Not Entered</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Location">
        <template scope="scope">
          <span v-if="beds[scope.row.id]">
          {{ unitById(scope.row.unitId) }} / {{ beds[scope.row.id].displayText }}
          </span>
          <span v-else>
          Not Assigned
          </span>
        </template>
      </el-table-column>
  </div>
</template>

<script>
import auth from '../auth'

// import moment from 'moment'
import SurveillanceCaseDetail from '../components/SurveillanceCaseDetail'
import SurveillanceCommunication from '../components/SurveillanceCommunication'
import SurveillanceBiology from '../components/SurveillanceBiology'
import SurveillanceDevice from '../components/SurveillanceDevice'
import SurveillanceSymptoms from '../components/SurveillanceSymptoms'
import SurveillanceTreatment from '../components/SurveillanceTreatment'
import SurveillancePersonalInfo from '../components/SurveillancePersonalInfo'
import SurveillancePrecaution from '../components/SurveillancePrecaution'

module.exports = {
  name: 'clients',
  components: {
    'surveillance-case-detail': SurveillanceCaseDetail,
    'surveillance-communication': SurveillanceCommunication,
    'surveillance-biology': SurveillanceBiology,
    'surveillance-device': SurveillanceDevice,
    'surveillance-symptoms': SurveillanceSymptoms,
    'surveillance-treatment': SurveillanceTreatment,
    'surveillance-personal-info': SurveillancePersonalInfo,
    'surveillance-precaution': SurveillancePrecaution
  },
  data: function () {
    return {
      currentDate: new Date(),
      cases: [],
      precautions: [],
      beds: {},
      symptomTypes: [],
      searchNameInput: '',
      clients: []
    }
  },
  methods: {
    loadPrecautions: function () {
      var vm = this
      this.$http.get(window.CONFIG.api + '/precautions/')
      .then(response => {
        vm.precautions = response.body['_embedded'].precautions
        vm.loadUnits()
      }, response => {
        // error callback
      })
    },
    loadUnits: function () {
      var vm = this
      this.$http.get(window.CONFIG.api + '/units', {
        headers: {
          'Authorization': 'Bearer ' + auth.getToken()
        }
      })
      .then(response => {
        vm.units = response.body['_embedded'].units
        vm.graphConfig = { units: vm.units }

        if (vm.selectedUnit === null && vm.units && vm.units.length > 0) {
          vm.selectedUnit = vm.units[0].value
        }

        vm.units.forEach(function (u) {
          vm.loadRooms(u)
        })
      })
    },
    loadRooms: function (unit) {
      var vm = this
      this.$http.get(window.CONFIG.api + '/units/' + unit.id + '/rooms')
      .then(response => {
        // console.log(response)
        var rooms = response.body['_embedded'].rooms
        rooms.forEach(function (room) {
          var beds = room.beds
          beds.forEach(function (bed) {
            console.log(JSON.stringify(bed))
            vm.beds[bed.occId] = {
              displayText: room.displayText + '-' + bed.displayText,
              bed: bed
            }
            console.log(vm.beds[bed.occId].displayText)
          })
        })

        vm.loadClients()
      }, response => {

      })
    },
    clientName: function (clientData) {
      var firstName = clientData.firstName ? clientData.firstName + ' ' : ''
      var middleName = clientData.middleName ? clientData.middleName + ' ' : ''
      var lastName = clientData.lastName ? clientData.lastName : ''

      return firstName + middleName + lastName
    },
    loadClients: function () {
      var vm = this

      this.$http.get(window.CONFIG.api + '/clients')
      .then(response => {
        if (response.body) {
          vm.clients = response.body['_embedded'].clients
        } else {
          console.log('no content')
          vm.clients = []
        }
      }, response => {
        // error callback
      })
    },
    photoUrl: function (f) {
      return '/static/' + f + '.png'
    },
    precautionById: function (precautionId) {
      var name = ''
      this.precautions.forEach(function (p) {
        if (p.id === precautionId) {
          name = p.displayText
        }
      })

      return name
    },
    unitById: function (unitId) {
      var unitName = ''
      this.units.forEach(function (u) {
        if (u.id === unitId) {
          unitName = u.displayText
        }
      })

      return unitName
    },
    nameFilter: function (clients) {
      var vm = this
      return clients.filter(function (client) {
        return vm.clientName(client).toLowerCase().includes(vm.searchNameInput.toLowerCase())
      })
    }
  },
  mounted: function () {
    this.loadPrecautions()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.graph {
    overflow-x: scroll;
    position: relative;
    width: 100%;
    height: 450px;
    padding: 1em;
}

.graph > canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 1500px;
  pointer-events:none;
}

.el-card {
    margin-bottom: 1em;
}

.profile-photo img {
    width: 10em;
    height: 10em;
    border-radius: 50%;
    position: absolute;
    right: 2.5em;
    top: 0.5em;
}

.profile-row-photo img {
    width: 3em;
    height: 3em;
    border-radius: 50%;
}

.dialog-case-detail div {
    line-height: 3em;
}

.input-boxes {
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
}

.clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }

.clearfix {
    clear: both;
}

/*.el-button {
  width: 100%;
}*/

.el-tag {
    margin-right: 0.5em;
}

.color-code-label-0 {
    width: 1em;
    height: 1em;
    background: #00D560;
    display: inline-block;
    vertical-align: middle;
    border-style: solid;
    border-width: 1px;
    border-color: lightgrey;
}
.color-code-label-1 {
    width: 1em;
    height: 1em;
    background: #0080FF;
    display: inline-block;
    vertical-align: middle;
    border-style: solid;
    border-width: 1px;
    border-color: lightgrey;
}
.color-code-label-2 {
    width: 1em;
    height: 1em;
    background: #FFDE25;
    display: inline-block;
    vertical-align: middle;
    border-style: solid;
    border-width: 1px;
    border-color: lightgrey;
}

.graph-filter > .el-radio-group {
    padding: 15px;
    float: right;
}
.graph-filter {
    margin-right: 1em;
    margin-left: 3em;
    position: absolute;
    right: 0;
    top: -0.5em;
}
.case-filter {
    margin-right: 1em;
    margin-left: 3em;
    position: absolute;
    right: 0;
    top: 0.5em;
}
.filter-title-label {
  margin-left: 2em;
  margin-right: 1em;
  text-align: right;
  line-height: 40px;
}
.filter-section > label {
  display: inline-block;
}
.filter-section {
  margin: 1em;
  padding-bottom: 0.7em;
  display: table-cell;
  vertical-align: middle;
  height: 50px;
  padding-top: 0.5em;
}
.filter-section-input {
  float: right;
}
.symptom-status-image {
  width: 36px;
  position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
.symptom-detail-status-image {
  width: 36px;
  position: absolute;
  margin: auto;
  margin-left: 5px;
  top: 5px;
}
.case-note {
  max-height: 15em;
  width: 100%;
  overflow-y: scroll;
}

.dialog-case-detail div.case-note-date {
  float: right;
  padding: 1em;
  font-size: 1.0em;
  font-weight: 500;
  line-height: 1.8em;
}

.dialog-case-detail div.case-note-content {
  padding: 1em;
  border-bottom: 1px solid #EEEEEE ;
  line-height: 1.8em;
}

.case-note::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 5px;
}

.case-note::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: rgba(0,0,0,.5);
  -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
}

.surveillance .el-tabs__item {
    font-size: 1em;
    padding: 0 10px 0 10px;
}

.surveillance .el-dialog.el-dialog--large {
    width: 80% !important;
}
</style>



// WEBPACK FOOTER //
// Clients.vue?d47e5018